<p-accordion
  expandIcon="pi pi-chevron-right"
  class="flex flex-col"
  [value]="[0]"
  [dt]="dt"
  [multiple]="true"
  (onOpen)="isSelectHPError = true"
>
  <p-accordion-panel [value]="0" data-test-id="select-health-plan-accordion">
    <p-accordion-header [pt]="pt">Select Health Plan</p-accordion-header>
    <p-accordion-content>
      <p-select
        placeholder="Select"
        optionLabel="displayName"
        [ariaLabel]="'Select Tenant'"
        [options]="tenantList"
        [(ngModel)]="selectedTenant"
        (onChange)="onSelectTenant($event)"
        class="w-full"
        data-test-id="select-health-plan-dropdown">
      </p-select>
      @if (isSelectHPError && !selectedTenant) {
        <errors-messages-inline>
          Please select a Health Plan.
        </errors-messages-inline>
      }
    </p-accordion-content>
  </p-accordion-panel>

  @if (canDoSearch) {
    <p-accordion-panel [value]="1" *accessView="['MemberPage.UI']" data-test-id="search-by-member-accordion">
      <p-accordion-header [pt]="pt">Search By Member</p-accordion-header>
      <p-accordion-content>
        <form [formGroup]="searchForm" autocomplete="off">
          @if (shouldShowExtendedSearchFields) {
            <div class="member-id-textbox mb-2">
              <div class="col-span-12">
                <div>
                  <input
                    pInputText
                    type="text"
                    class="w-full"
                    formControlName="lastName"
                    placeholder="Last Name"
                    data-test-id="last-name-input"
                    aria-label="Last Name"
                  />
                  @if (memberLastNameInput.invalid && (memberLastNameInput.dirty || memberLastNameInput.touched)) {
                    <errors-messages-inline>
                      Please enter a valid last name
                    </errors-messages-inline>
                  }
                  @if (memberLastNameInput.hasError('memberId') && (memberLastNameInput.dirty || memberLastNameInput.touched)) {
                    <errors-messages-inline>
                      Last name is <strong>required</strong>
                    </errors-messages-inline>
                  }
                </div>
              </div>
            </div>
          }
          <div class="member-id-textbox mb-2">
            <div class="col-span-12">
              <div>
                <input
                  pInputText
                  type="text"
                  class="w-full"
                  formControlName="memberId"
                  placeholder="Member ID"
                  data-test-id="member-id-input"
                  aria-label="Member ID"
                />
                @if (memberIdInput.invalid && (memberIdInput.dirty || memberIdInput.touched)) {
                  <errors-messages-inline>
                    Please enter a valid member number
                  </errors-messages-inline>
                }
                @if (memberIdInput.hasError('memberId') && (memberIdInput.dirty || memberIdInput.touched)) {
                  <errors-messages-inline>
                    Member Number is <strong>required</strong>
                  </errors-messages-inline>
                }
              </div>
            </div>
          </div>
          @if (shouldShowExtendedSearchFields) {
            <div class="member-id-textbox mb-2">
              <div class="col-span-12">
                <div>
                  <div class="p-field-value">
                    <p-date-picker
                      inputId="date-of-birth"
                      formControlName="dateOfBirth"
                      dateFormat="mm/dd/yy"
                      selectionMode="single"
                      [monthNavigator]="true"
                      [yearNavigator]="true"
                      [showButtonBar]="true"
                      [yearRange]="yearOfBirthRange"
                      [maxDate]="birthDateMaxSelectableDate"
                      [showIcon]="true"
                      appendTo="body"
                      placeholder="Date of Birth"
                      data-test-id="date-of-birth-calendar"
                    ></p-date-picker>
                  </div>
                  @if (memberDOBInput.invalid && (memberDOBInput.dirty || memberDOBInput.touched)) {
                    <errors-messages-inline>
                      Please enter a valid Date of Birth
                    </errors-messages-inline>
                  }
                  @if (memberDOBInput.hasError('memberId') && (memberDOBInput.dirty || memberDOBInput.touched)) {
                    <errors-messages-inline>
                      Date of Birth is <strong>required</strong>
                    </errors-messages-inline>
                  }
                </div>
              </div>
            </div>
          }
        </form>
        <div class="flex justify-end mt-4">
          <button
            pButton
            type="button"
            class="w-full"
            icon="pi pi-search"
            label="Search"
            [disabled]="searchForm.invalid || !selectedTenant"
            (click)="onSearchMember()"
            data-test-id="search-by-member-button"
          ></button>
        </div>
      </p-accordion-content>
    </p-accordion-panel>

    <p-accordion-panel [value]="2" *accessView="['AuthorizationPage.UI', 'HH.Authorization.Read', 'PACIMAuthorization.Read']" data-test-id="search-by-auth-accordion">
      <p-accordion-header [pt]="pt">Search By Auth</p-accordion-header>
      <p-accordion-content>
        <form [formGroup]="searchAuthForm" autocomplete="off">
          <div class="member-id-textbox">
            <div>
                <input
                  pInputText
                  pKeyFilter="alphanum"
                  type="text"
                  (paste)="onPasteAuthNumber($event)"
                  (input)="resetAuthNumberValidators()"
                  class="w-full"
                  formControlName="authorizationNumber"
                  placeholder="Authorization Number"
                  aria-label="Authorization Number"
                  data-test-id="auth-number-input"
                />
                @if (authorizationNumberInput.invalid && (authorizationNumberInput.dirty || authorizationNumberInput.touched)) {
                  <errors-messages-inline>
                    Please enter a valid authorization number
                  </errors-messages-inline>
                }
                @if (authorizationNumberInput.hasError('authorizationNumber') && (authorizationNumberInput.dirty || authorizationNumberInput.touched)) {
                  <errors-messages-inline>
                    Authorization Number is <strong>required</strong>
                  </errors-messages-inline>
                }
            </div>
          </div>
        </form>
        <div class="flex justify-end mt-4">
          <button
            pButton
            class="w-full"
            icon="pi pi-search"
            type="button"
            label="Search"
            (click)="onSearchAuth()"
            [disabled]="searchAuthForm.invalid || !selectedTenant"
            data-test-id="search-by-auth-button"
          ></button>
        </div>
      </p-accordion-content>
    </p-accordion-panel>
  }

  @if (isExternalUser && canDoClaimsSearch) {
    <ng-container *accessView="['Claims.Read']">
      <p-accordion-panel [value]="3" data-test-id="search-by-payment-accordion">
        <p-accordion-header [pt]="pt">Search By Payment</p-accordion-header>
        <p-accordion-content>
          <app-claim-search [tenantId]="activeTenantId" [tenantName]="activeTenantName" />
        </p-accordion-content>
      </p-accordion-panel>
      <p-accordion-panel [value]="4" data-test-id="search-by-claim-accordion">
        <p-accordion-header [pt]="pt">Search By Claim</p-accordion-header>
        <p-accordion-content>
          <app-claim-search-details
            [tenantId]="activeTenantId"
            [tenantName]="activeTenantName"
          />
        </p-accordion-content>
      </p-accordion-panel>
    </ng-container>
  }
</p-accordion>

@if (isExternalUser && activeTenantId && activeTenantId !== 'none') {
  <div class="sidebar-buttons" *accessView="['DMEPOSProviderDashboard.Read']">
    <button
      type="button"
      data-test-id="provider-dashboard-button"
      [class]="{ 'active': viewingProviderDashboard() }"
      (click)="goToProviderDashboard()">
      <i class="pi pi-table"></i>
      Provider Dashboard
    </button>
  </div>
}

<div class="menu-separator"></div>
<div class="sidebar-buttons">
  <ng-container
    *accessView="['AdvancedSearchMember.Read', 'AdvancedSearchServiceProvider.Read', 'AdvancedSearchOrderingFollowingProvider.Read']">
    @if (!isExternalUser) {
      <button
        type="button"
        data-test-id="advanced-search-button"
        (click)="goToAdvancedSearchPage()"
        [class]="{'active': menu === 'advancedsearch' }"
      >
        <i aria-hidden="true" class="pi pi-search"></i>
        Advanced Search
      </button>
    }
  </ng-container>
</div>
